module.exports = __webpack_public_path__ + "img/squiggles.2cd66b78.png";